<template>
    <div>
        <bootcamps-list-component
            :url="url_get"
            :is_super_admin="is_super_admin"
        ></bootcamps-list-component>

        <createbootcamp-component
            :get_url="url_get"
            @onsaved="refreshBootcamps"
            v-if="is_super_admin"
        ></createbootcamp-component>
    </div>
</template>

<script>
    export default {
        props: ["url_get", "is_super_admin"],
        data() {
            return {

            }
        },
        mounted(){
        },
        methods:{
            refreshBootcamps(){
                this.$emit('refreshbootcamps');
            }
        }
    }
</script>

<style>

</style>
